import { Navigate } from 'react-router';
import SiteWrapper from '@/components/Layout';
import { useAuth } from '@/providers/AuthProvider';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const authed = useAuth();
  return authed ? <SiteWrapper>{children}</SiteWrapper> : <Navigate to="/" />;
};

export default PrivateRoute;
